(() => {
  if (Number(window.Shopify?.theme?.id) !== 210301813004) return;
  const hero=document.querySelector('.anom-home-display .aq-hero');
  if(!hero) return;
  function sizeHero() {
    const top=hero.getBoundingClientRect().top+window.scrollY;
    const marquee=document.querySelector('.anom-farm-bar')||document.querySelector('[id*="custom_title_bar"]');
    const band=marquee?.getBoundingClientRect().height||64;
    const mobile=window.matchMedia('(max-width:749px)').matches;
    document.documentElement.style.setProperty('--as-hero-offset',`${Math.max(0,top)+(mobile?band:0)}px`);
  }
  requestAnimationFrame(sizeHero);
  document.fonts?.ready.then(sizeHero);
  window.addEventListener('resize',sizeHero,{passive:true});
  const header=document.querySelector('.section-header');
  if(header&&window.ResizeObserver) new ResizeObserver(sizeHero).observe(header);
  const marquee=document.querySelector('.anom-farm-bar');
  if(marquee&&window.ResizeObserver) new ResizeObserver(sizeHero).observe(marquee);
  const observer=new MutationObserver(()=>{const preview=document.getElementById('PBarNextFrameWrapper');if(preview){sizeHero();new ResizeObserver(sizeHero).observe(preview);observer.disconnect();}});
  observer.observe(document.body,{childList:true,subtree:true});
})();
